import moment, { Moment } from "moment";

const ISO8601 = "YYYY-MM-DD";

export const formatDate = (date: string, format: string) => moment(date).format(format);

export const readableDate = (date: moment.MomentInput, inputFormat?: string) =>
  moment(date, inputFormat).format("MMMM Do, YYYY");

export const formatToISO8601 = (date: string | Moment, inputFormat?: string) => moment(date, inputFormat).format(ISO8601);

export const formatToUtc = (date: string, format?: string) => moment.utc(date).format(format || "MM/DD/YYYY");

export function getExpiresIn(date: string) {
  const days = moment(date, ISO8601).diff(moment().startOf("day"), "days");

  switch (days) {
    case 0:
      return "today";
    case 1:
      return "tomorrow";
  }
  return `in ${days} days`;
}
